import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useSpring, animated } from '@react-spring/web';

function ContactForm() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        role: "",
        phone: "",
        teams: "",
        source: "",
        additionalInfo: "",
    });

    const [ref, inView] = useInView({ triggerOnce: true });
    const animation = useSpring({
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(50px)',
        config: { duration: 1000 }
    });

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const mailtoLink = `mailto:info@dataqly.com?subject=Contact%20Dataqly&body=
            Name: ${formData.name}%0A
            Email: ${formData.email}%0A
            Role: ${formData.role}%0A
            Phone: ${formData.phone}%0A
            Number of Data Teams: ${formData.teams}%0A
            How did you hear about dataqly?: ${formData.source}%0A
            Additional Information: ${formData.additionalInfo}`;

        window.location.href = mailtoLink;
    };

    return (
        <animated.section id="contact" ref={ref} style={{ ...sectionStyles(isMobile), ...animation }}>
            <h2 style={titleStyles(isMobile)}>Get in Touch</h2>
            <p style={descriptionStyles(isMobile)}>
                If You’re Ready To Go From Data Chaos To Clarity — Let’s Talk.
            </p>
            <form style={formStyles(isMobile)} onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Name" required style={inputStyles(isMobile)} onChange={handleChange} />
                <input type="email" name="email" placeholder="Email" required style={inputStyles(isMobile)} onChange={handleChange} />
                <input type="text" name="role" placeholder="Role" required style={inputStyles(isMobile)} onChange={handleChange} />
                <input type="tel" name="phone" placeholder="Phone Number (Optional)" style={inputStyles(isMobile)} onChange={handleChange} />
                <input type="number" name="teams" placeholder="Number of Data Teams" required style={inputStyles(isMobile)} min="1" onChange={handleChange} />
                <select name="source" required style={inputStyles(isMobile)} onChange={handleChange}>
                    <option value="" disabled selected>How did you hear about dataqly?</option>
                    <option value="LinkedIn">LinkedIn</option>
                    <option value="Google Search">Google Search</option>
                    <option value="Friend">Friend</option>
                    <option value="Referral">Referral</option>
                    <option value="Online Ad">Online Ad</option>
                    <option value="Webinar">Webinar</option>
                </select>
                <textarea name="additionalInfo" placeholder="Additional Information (Optional)" style={textareaStyles(isMobile)} onChange={handleChange}></textarea>
                <button type="submit" style={buttonStyles(isMobile)}>Contact Us</button>
            </form>
        </animated.section>
    );
}

const sectionStyles = (isMobile) => ({
    padding: isMobile ? '40px 10px' : '80px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    borderRadius: '8px',
    marginTop: "100px",
    marginBottom: "100px",
});

const subtitle = (isMobile) => ({
    fontSize: isMobile ? "1rem" : "1.1rem",
    color: "#667",
    textTransform: "uppercase",
});

const titleStyles = (isMobile) => ({
    fontSize: isMobile ? '2.1rem' : '2.5rem',
    fontWeight: "bold",
    color: "#000",
    textAlign: "center",
    marginBottom: "1.5rem",
});

const descriptionStyles = (isMobile) => ({
    fontSize: isMobile ? "1rem" : "1.2rem",
    maxWidth: "50rem",
    margin: "0 auto",
    marginBottom: "40px",
    fontWeight: 400,
    color: "#808080",
});

const formStyles = (isMobile) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
    maxWidth: isMobile ? '100%' : '500px',
});

const inputStyles = (isMobile) => ({
    padding: '12px 20px',
    fontSize: '1rem',
    borderRadius: '30px',
    border: '2px solid var(--input-border-color)',
    outline: 'none',
    width: '100%',
    transition: 'all 0.3s ease',
    background: '#fff',
    boxShadow: '0 0 10px var(--button-shadow-color)',
    boxSizing: 'border-box',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    fontFamily: 'Inter, sans-serif',
});

const textareaStyles = (isMobile) => ({
    ...inputStyles(isMobile),
    height: '120px',
    resize: 'vertical',
    borderRadius: '30px',
});

const buttonStyles = (isMobile) => ({
    padding: '12px 24px',
    fontSize: isMobile ? '0.8rem' : '1rem',
    color: '#fff',
    background: 'black',
    width: isMobile ? '40%' : '30%',
    margin: '0 auto',
    border: 'none',
    borderRadius: '30px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 0 10px var(--button-shadow-color)',
});

export default ContactForm;
